// extracted by mini-css-extract-plugin
module.exports = {"tabs__list":"Tabs_tabs__list__c88Dg","tabs__stage":"Tabs_tabs__stage__NLUwm"};